import React from 'react'
import { Field, FormikProps } from 'formik'
import get from 'lodash/get'
import { IPackInput, IEditionMetadata } from '../../types/pack'
import { Space } from '../../layouts'
import {
  H3,
  CustomCheckboxField,
  CustomCheckboxGroupField,
  P,
} from '../../components'

interface IEditionPublishOptionsFragment {
  index: number
  edition?: IEditionMetadata
  isFormDisabled: boolean
  formikProps: FormikProps<IPackInput>
}

export const EditionPublishOptionsFragment = ({
  index,
  edition,
  isFormDisabled,
  formikProps,
}: IEditionPublishOptionsFragment) =>
  index !== -1 && !!edition ? (
    <div key={index}>
      {/* Rerender component on index changes */}
      {!!get(edition, 'publishing.locations[0]') && (
        <>
          <H3>Available locations</H3>
          <Space mb={3}>
            {edition.publishing.locations.map(({ title, name }) => (
              <P key={name}>
                <Field
                  name={`editions.${index}.publishingLocations`}
                  label={title}
                  fieldValue={name}
                  component={CustomCheckboxGroupField}
                  disabled={!!isFormDisabled}
                  onChange={(e) => {
                    // Uncheck searchable in Lynx checkbox when Available locations checkbox is unchecked
                    const publishingLocations = get(
                      formikProps.values,
                      `editions.${index}.publishingLocations`,
                      []
                    )
                    if (
                      !e.target.checked &&
                      publishingLocations!.length === 1 &&
                      publishingLocations!.includes(name)
                    ) {
                      formikProps.setFieldValue(
                        `editions.${index}.isLynxSearchable`,
                        false
                      )
                    }
                  }}
                />
              </P>
            ))}
          </Space>
        </>
      )}
      {edition.publishing.promoDestinations.length > 0 && (
        <Space>
          <H3>Searchable</H3>
          <Field
            name={`editions.${index}.isLynxSearchable`}
            label="Searchable in Lynx"
            component={CustomCheckboxField}
            disabled={
              !formikProps.values.editions[index].publishingLocations.length ||
              !!isFormDisabled
            }
          />
        </Space>
      )}
    </div>
  ) : null
